@if (!showPicker) {
  <dialog-header [title]="'New project'"></dialog-header>
  <div class="content" [formGroup]="form">
    <div class="project-form">
      <button class="toggle-picker" (click)="togglePicker()">
        <div [style.background-color]="(selectedColor$ | async) || '#C7C2B6'"></div>
        <oph-icon [name]="'chevron-down-brown'" [size]="16"></oph-icon>
      </button>
      <oph-input [control]="$any(form.controls['label'])" placeholder="Name your project" [height]="56"></oph-input>
    </div>
  </div>
  <div class="footer">
    <div class="buttons-container">
      <oph-button
        (buttonClick)="onClose()"
        appearance="outline"
        [style]="{'border-width': '1px', 'border-radius': '12px'}"
        >Cancel</oph-button
      >
      <oph-button (buttonClick)="onNext()" color="green">Next</oph-button>
    </div>
  </div>
} @else {
  <oph-color-picker
    [colors]="colors"
    [onCancel]="togglePicker.bind(this)"
    (selectedColor)="onColorSelected($event)"
  ></oph-color-picker>
}
